import {createGetQuery} from '../hooks/useQuery'



export type PackageVehicle = {
    code: string
    color: number
    id: number
    name: string
}

export type PackageFee = {
    amount: number
    appliesToFeeIds: number[]
    default: boolean
    id: number
    name: string
    type: 'FIXED'|'PERCENT'
}


export const usePackageVehicles = createGetQuery<PackageVehicle[]>('vehicles.json', {initialData: []})
export const usePackageFees = createGetQuery<PackageFee[]>('fees.json', {initialData: []})
